import {
  TAnaliseInsight,
  TAvaliarInsightResponse
} from "../../services/InsightsAIDreGateway";
import { IInsightsIASummaryItem } from "../../types";

export type TInsightsDreRelatorioState = {
  insights: TAnaliseInsight[];
  summaryItems: IInsightsIASummaryItem | null;
  secondarySummaryItems: IInsightsIASummaryItem[];
  quantidadeInsights: number;
  criticos: number;
  atencao: number;
  infos: number;
  analiseVertical?: boolean;
  competenciaAte?: string;
  competenciaDe?: string;
  dataCriacao?: string;
  disponivel?: boolean;
  id?: string;
  idEmpresa?: string;
  idModelo?: string;
  nomeFantasia?: string;
  modelo?: string;
};

export const useInsightsDreRelatorio = () => {
  const relatorioState = (): TInsightsDreRelatorioState => ({
    insights: [],
    summaryItems: null,
    secondarySummaryItems: [],
    quantidadeInsights: 0,
    criticos: 0,
    atencao: 0,
    infos: 0,
    analiseVertical: undefined,
    competenciaAte: undefined,
    competenciaDe: undefined,
    dataCriacao: undefined,
    disponivel: undefined,
    id: undefined,
    idEmpresa: undefined,
    idModelo: undefined,
    nomeFantasia: undefined,
    modelo: undefined
  });

  const setInsights = (
    relatorioState: TInsightsDreRelatorioState,
    insights: TAnaliseInsight[]
  ) => {
    relatorioState.insights = insights.map((insight) => ({
      ...insight,
      isExpanded: false,
      id: insight.id.toString(),
      order: insight.order,
      title: insight.title,
      severity: insight.severity,
      summary: insight.summary,
      riskDescription: insight.riskDescription,
      suggestedActions: insight.suggestedActions
    }));
  };

  const setSummaryItems = (
    relatorioState: TInsightsDreRelatorioState,
    quantidadeInsights: number
  ) => {
    relatorioState.summaryItems = {
      label: "Insights gerados",
      value: quantidadeInsights || 0,
      icon: "insights",
      severity: "Infos"
    };
  };

  const setSecondarySummaryItems = (
    relatorioState: TInsightsDreRelatorioState,
    criticos: number,
    atencao: number,
    infos: number
  ) => {
    relatorioState.secondarySummaryItems = [
      {
        label: "Críticos",
        value: criticos,
        icon: "insights",
        severity: "Critical"
      },
      {
        label: "Atenção",
        value: atencao,
        icon: "insights",
        severity: "Warning"
      },
      {
        label: "Infos",
        value: infos,
        icon: "insights",
        severity: "Infos"
      }
    ];
  };

  const setInsightExpanded = (
    relatorioState: TInsightsDreRelatorioState,
    id: string,
    isExpanded: boolean
  ) => {
    relatorioState.insights = relatorioState.insights.map((insight) =>
      insight.id.toString() === id
        ? {
            ...insight,
            isExpanded,
            severity: insight.severity
          }
        : insight
    );
  };

  const setInsightUsefulInsight = (
    relatorioState: TInsightsDreRelatorioState,
    id: string,
    usefulInsight: boolean
  ) => {
    relatorioState.insights = relatorioState.insights.map((insight) =>
      insight.id.toString() === id ? { ...insight, usefulInsight } : insight
    );
  };

  const setDadosAgenteDeDre = (
    relatorioState: TInsightsDreRelatorioState,
    dados: Partial<TAvaliarInsightResponse>
  ) => {
    relatorioState.analiseVertical = dados.analiseVertical || undefined;
    relatorioState.competenciaAte = dados.competenciaAte || undefined;
    relatorioState.competenciaDe = dados.competenciaDe || undefined;
    relatorioState.dataCriacao = dados.dataCriacao || undefined;
    relatorioState.disponivel = dados.disponivel || undefined;
    relatorioState.id = dados.id || undefined;
    relatorioState.idEmpresa = dados.idEmpresa || undefined;
    relatorioState.idModelo = dados.idModelo || undefined;
    relatorioState.nomeFantasia = dados.nomeFantasia || undefined;
    relatorioState.modelo = dados.idModelo || undefined;
  };

  const resetRelatorio = (relatorioState: TInsightsDreRelatorioState) => {
    relatorioState.insights = [];
    relatorioState.summaryItems = null;
    relatorioState.secondarySummaryItems = [];
    relatorioState.quantidadeInsights = 0;
    relatorioState.criticos = 0;
    relatorioState.atencao = 0;
    relatorioState.infos = 0;
    relatorioState.analiseVertical = undefined;
  };

  return {
    relatorioState,
    setInsights,
    setSummaryItems,
    setSecondarySummaryItems,
    setInsightExpanded,
    setInsightUsefulInsight,
    setDadosAgenteDeDre,
    resetRelatorio
  };
};
